// extracted by mini-css-extract-plugin
export default {"cardIcon":"CreditCardLogo_cardIcon__f5KUK"};